import { RespuestaBase } from '.';

export class Respuesta extends RespuestaBase {
  titulo?: string;
}
